import { getCtx } from '../ctxSingleton';

export const ctxOk = (ctx?: BaseAudioContext | null): boolean => !!ctx && (ctx as any).state !== 'closed';

/** True if node has a live context and is owned by the current singleton context */
export function belongsToLiveCtx(node?: AudioNode | null): boolean {
  if (!node) return false;
  const nodeCtx = (node as any)?.context as AudioContext | undefined;
  const live = getCtx();
  return !!nodeCtx && ctxOk(nodeCtx) && nodeCtx === live;
}

export function safeConnectCtx(
  ctx: BaseAudioContext | null | undefined,
  from?: any,
  to?: any,
  out: number = 0,
  inn: number = 0,
): boolean {
  if (!ctxOk(ctx)) return false;
  // Ensure nodes, if provided, belong to this live context to avoid cross-context wiring
  try {
    const live = getCtx();
    const fromCtx = (from as any)?.context as BaseAudioContext | undefined;
    const toCtx = (to as any)?.context as BaseAudioContext | undefined;
    if ((from && fromCtx && fromCtx !== live) || (to && toCtx && toCtx !== live)) return false;
  } catch {}
  try {
    from?.connect?.(to, out, inn);
    return true;
  } catch {
    return false;
  }
}
